export const getSpMode = (): boolean => {
  return 'ontouchstart' in window
}
